import { Injectable } from "@angular/core";
import { RequestObj } from "@shared/interface/request-obj.interface";
@Injectable()
export class Requestutility {
  constructor() { }
  public getRequestObj = (arrayOfObj: RequestObj[]) => {
    // return new Promise((resolve, reject) => {
      try {
        let obj = {};
        arrayOfObj.forEach(element => {
          if (element.isArrayOfObj) {
            let mainArr = [];
            element.value.forEach(arr => {
              let newObj = {};
              arr.forEach(object => {
                let res = this.returnObj(object);
                newObj = Object.assign(newObj, res);
              });
              mainArr.push(newObj);
            });
            obj[element.key] = mainArr;
          } else if (element.isArrayOfValues) {
            let valueArr = [];
            element.value.forEach(value => {
              if (element.isNumber) {
                valueArr.push(value && element.isNumber ? Number(value) : value);
              } else if (element.isString) {
                valueArr.push(value && element.isString && (element.isLowerCase || element.isTrim) ?
                  (element.isLowerCase && element.isTrim) ? value.trim().toLowerCase() :
                    element.isLowerCase ? value.toLowerCase() : value.trim() :
                  value);
              } else if (element.isNull) {
                valueArr = [null];
              }
            });
            obj[element.key] = valueArr;
          } else if (element.isObject) {
            let valueObj = {};
            element.value.forEach(pair => {
              let result = this.returnObj(pair);
              valueObj = Object.assign(valueObj, result);
            });
            obj[element.key] = valueObj;
          } else if (element.isBoolean) {
            obj[element.key] = element.value == 'true' || element.value == true ? true : false;
          } else if (element.isNumber || element.isString || element.isNull) {
            let result = this.returnObj(element);
            obj = Object.assign(obj, result);
          }
        });
        // resolve(obj);
        return obj;
      } catch (error) {
      }
    // })
    
  };

  returnObj = (element) => {
    let newObj = {};
    if (element.isNumber) {
      newObj[element.key] = element.value && element.isNumber ? Number(element.value) : element.value;
    } else if (element.isString) {
      newObj[element.key] = element.value && element.isString && (element.isLowerCase || element.isTrim) ?
        (element.isLowerCase && element.isTrim) ? element.value.trim().toLowerCase() :
          element.isLowerCase ? element.value.toLowerCase() : element.value.trim() :
        element.value;
    } else if (element.isNull || !element.value) {
      newObj[element.key] = element.isNull ? null : '';
    }
    return newObj;
  }
}